module.exports = __webpack_public_path__ + "static/media/img007.d1d41196.jpg";